var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C1.96591 4.14667 6.81818 0 12.5 0C18.1818 0 23.0341 4.14667 25 10C23.0341 15.8533 18.1818 20 12.5 20C6.81818 20 1.96591 15.8533 0 10ZM18.3333 10C18.3333 13.2217 15.7216 15.8333 12.5 15.8333C9.27832 15.8333 6.66665 13.2217 6.66665 10C6.66665 6.77833 9.27832 4.16666 12.5 4.16666C15.7216 4.16666 18.3333 6.77833 18.3333 10ZM12.5 13.3333C14.3409 13.3333 15.8333 11.8409 15.8333 10C15.8333 8.15905 14.3409 6.66666 12.5 6.66666C10.659 6.66666 9.16665 8.15905 9.16665 10C9.16665 11.8409 10.659 13.3333 12.5 13.3333Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisible);
export default __webpack_public_path__ + "static/media/visible.0706e17c3010486698f5ff4fff3b4315.svg";
export { ForwardRef as ReactComponent };